import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {replySubmitMutation, SendReplyInput} from './__generated__/replySubmitMutation.graphql';

const mutation = graphql`
	mutation replySubmitMutation($input: SendReplyInput!) {
		sendReply(input: $input) {
			clientMutationId
			message {
				id
				type
				authorType
				author {
					id
					...ticketingPerson_person
				}
				body
				bodyHtml
				direction
				deliveryStatus
				retryCount
				createdAt
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: SendReplyInput,
	onCompleted?: (r: replySubmitMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<replySubmitMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'replySubmitMutation'};
